import { slot } from "ts-event-bus";
import Geolocation from 'ol/Geolocation';
import { TwuidSearchResult, TwuidSearchSource } from "./TwuidSearchContracts";
import { UsrnSearchResult, UsrnSearchSource } from "./UsrnSearchContracts";

export interface TwuidSearchSuccessPayload {
    query: string;
    result: TwuidSearchResult;
    source: TwuidSearchSource;
}

export interface TwuidSearchFailurePayload {
    query: string;
    status?: number;
    source: TwuidSearchSource;
}

export interface UsrnSearchSuccessPayload {
    query: string;
    result: UsrnSearchResult;
    source: UsrnSearchSource;
}

export interface UsrnSearchFailurePayload {
    query: string;
    status?: number;
    source: UsrnSearchSource;
}

/** The map's exclusive interaction mode — owned by MapModeManager. */
export type MapMode = 'idle' | 'measure' | 'editing' | 'tracking';

export interface MapModeChangedPayload {
    from: MapMode;
    to: MapMode;
}

export interface GpxEditRequestedPayload {
    /** Route to edit, or null to draw a new route. */
    gpxGuid: string | null;
}

const TrailwiseEvents = {
    trackingStart: slot<string>(),
    trackingEnd: slot<string>(),
    trackingGeolocationChange: slot<Geolocation>(),
    twuidSearchSuccess: slot<TwuidSearchSuccessPayload>(),
    twuidSearchFailure: slot<TwuidSearchFailurePayload>(),
    usrnSearchSuccess: slot<UsrnSearchSuccessPayload>(),
    usrnSearchFailure: slot<UsrnSearchFailurePayload>(),
    mapModeChanged: slot<MapModeChangedPayload>(),
    gpxEditRequested: slot<GpxEditRequestedPayload>(),
    gpxRoutesChanged: slot<string>(),
    /** A slide-panel tab was opened (payload is its data-action), so its content now has layout. */
    slidePanelShown: slot<string>()
};

export default TrailwiseEvents;
